<template>
  <div class="headermain2">
    <img
      class="bcmicon"
      @click="handleClick"
      @mousedown="startDrag"
      @mousemove="onDrag"
      @mouseup="stopDrag"
      @mouseleave="stopDrag"
      :style="iconStyle"
      src="../assets/img/home/动画1.gif"
    />
    <el-drawer title="白草莓" :visible.sync="drawer" :append-to-body="true" direction="rtl" :before-close="handleClose">
      <iframe :src="iframeUrl" />
    </el-drawer>
  </div>
</template>

<script>
import router from '../router';
import axios from 'axios';
import { mapState } from 'vuex';
import { getFormatDateAdd, getSmpFormatDate, getFormatDateHourAdd } from '../utils/timeformat';
import { getweatherdata, getsbdatalist, getsbcount } from '@/api/bot';
export default {
  name: 'index',
  components: {},
  data() {
    return {
      drawer: false,
      isDragging: false,
      dragOffset: { x: 0, y: 0 },
      iconPosition: { x: window.innerWidth - 150, y: 460 }, // 初始位置在右上角
      dragStartPosition: { x: 0, y: 0 },
      hasDragged: false,
    };
  },
  computed: {
    ...mapState('user', ['userInfo']),
    iconStyle() {
      return {
        transform: `translate(${this.iconPosition.x}px, ${this.iconPosition.y}px)`,
      };
    },
    iframeUrl() {
      const baseUrl = 'https://strawberryai.web.shuzhiren.com/#/';
      const tenantId = this.userInfo?.tenantId || -1;
      const userId = this.userInfo?.userId || 3;
      const token = 'Bearer ' + localStorage.getItem('token');

      if (userId) {
        return `${baseUrl}?t=${token}&tenantId=${tenantId}&userId=${userId}`;
      }
      return baseUrl;
    },
  },
  mounted() {
    console.log('userInfo', this.userInfo);
  },
  methods: {
    handleClose() {
      this.drawer = false;
    },
    handleClick(event) {
      // 只有在没有拖拽的情况下才打开抽屉
      if (!this.hasDragged) {
        this.drawer = true;
      }
      // 重置拖拽状态
      this.hasDragged = false;
    },
    startDrag(event) {
      event.preventDefault();
      this.isDragging = true;
      this.hasDragged = false;
      this.dragStartPosition = { x: event.clientX, y: event.clientY };
      const rect = event.target.getBoundingClientRect();
      this.dragOffset = {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top,
      };
    },
    onDrag(event) {
      if (!this.isDragging) return;

      // 计算拖拽距离
      const dragDistance = Math.sqrt(
        Math.pow(event.clientX - this.dragStartPosition.x, 2) + Math.pow(event.clientY - this.dragStartPosition.y, 2)
      );

      // 如果拖拽距离超过5像素，标记为已拖拽
      if (dragDistance > 5) {
        this.hasDragged = true;
      }

      const newX = event.clientX - this.dragOffset.x;
      const newY = event.clientY - this.dragOffset.y;

      // 限制拖拽范围，防止拖出屏幕
      const maxX = window.innerWidth - 150; // 图片宽度
      const maxY = window.innerHeight - 150; // 图片高度

      this.iconPosition = {
        x: Math.max(0, Math.min(newX, maxX)),
        y: Math.max(0, Math.min(newY, maxY)),
      };
    },
    stopDrag() {
      this.isDragging = false;
    },
  },
};
</script>

<style scoped lang="less">
@font-face {
  font-family: 'title';
  src: url('../assets/font/title.ttf');
}

.headermain2 {
  .bcmicon {
    width: 150px;
    position: fixed;
    left: 0px;
    top: 0px;
    z-index: 9;
    cursor: move;
    user-select: none;
    transition: none; // 移除过渡效果以便拖拽更流畅
  }

  /deep/ .el-drawer__header {
    display: none !important;
  }
}

iframe {
  width: 100%;
  height: calc(100% - 10px);
  border: 0;
}

/deep/ .el-drawer__header {
  display: none;
}
</style>
